import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "tj_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 402 Paywall interceptor + 401 SUSPENDED interceptor.
// Callers can opt-out of the paywall redirect (background/analytics fetches)
// via config.skipPaywallRedirect = true.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    const code = err.response?.data?.detail?.code;
    const skip = err.config?.skipPaywallRedirect === true;
    if (status === 401 && code === "SUSPENDED") {
      const already = window.location.pathname === "/login";
      // Wipe the token — the existing session is dead.
      setToken(null);
      try { sessionStorage.setItem("tj_suspended_toast", "1"); } catch (_) { /* intentionally swallowed: sessionStorage may throw in private/Safari mode; toast hint is best-effort */ }
      if (!already) {
        window.location.assign("/login?suspended=1");
      }
      return Promise.reject(err);
    }
    if (status === 402 && code === "paywall_required" && !skip) {
      const already = window.location.pathname.startsWith("/settings/subscription");
      if (!already) {
        try {
          sessionStorage.setItem("tj_paywall_toast", "1");
        } catch (_) { /* intentionally swallowed: sessionStorage may throw in private/Safari mode; toast hint is best-effort */ }
        window.location.assign("/settings/subscription?paywall=1");
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : (e && typeof e.message === "string" ? e.message : JSON.stringify(e))))
      .filter(Boolean)
      .join(" ");
  // Structured error from backend hardening: { code, message, ... }
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  try {
    return JSON.stringify(detail);
  } catch (_) {
    return "An unexpected error occurred. Please try again.";
  }
}
